__turbopack_context__.v({
  "captchaBadge": "EmailTripDialog-module__0igoMa__captchaBadge",
  "footer": "EmailTripDialog-module__0igoMa__footer",
  "form": "EmailTripDialog-module__0igoMa__form",
  "marketingCopy": "EmailTripDialog-module__0igoMa__marketingCopy",
  "privacy": "EmailTripDialog-module__0igoMa__privacy",
});
